export const tableColumn = [
  {
    title: '预警任务名称',
    dataIndex: 'taskName',
    key: 'taskName',
    width: '200px',
  },
  // {
  //   title: '阀值方案',
  //   dataIndex: 'schemeId',
  //   key: 'schemeId',
  //   width: '150px',
  // },
  {
    title: '产品名称',
    dataIndex: 'dbtIds',
    key: 'dbtIds',
    width: '200px',
  },
  {
    title: '状态',
    dataIndex: 'enable',
    key: 'enable',
    width: '80px',
  },
  {
    title: '触发规则',
    dataIndex: 'triggerType',
    key: 'triggerType',
    width: '150px',
  },
  {
    title: '提醒人',
    dataIndex: 'notifyUserInfo',
    key: 'notifyUserInfo',
    width: '200px',
  },
  {
    title: '提醒群组',
    dataIndex: 'notifyFeishuChatName',
    key: 'notifyFeishuChatName',
    width: '200px',
  },
  {
    title: '创建人',
    dataIndex: 'createUser',
    key: 'createUser',
    width: '120px',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: '120px',
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    width: '160px',
  },
  {
    title: '操作',
    key: 'action',
    dataIndex: 'action',
    align: 'right',
    width: '120px',
    fixed: 'right',
  },
]

// 预警状态：开启/关闭
export const ENABLE_STATUS = {
  ON: 1,
  OFF: 0,
}

export const ENABLE_STATUS_OPTIONS = [
  { label: '开启', value: ENABLE_STATUS.ON },
  { label: '关闭', value: ENABLE_STATUS.OFF },
]

// 选品方式：1-按条件筛选，2-指定产品
export const CHOOSE_TYPE = {
  BY_CONDITION: 1,
  SPECIFIED_PRODUCT: 2,
}

export const CHOOSE_TYPE_OPTIONS = [
  // { label: '按条件筛选', value: CHOOSE_TYPE.BY_CONDITION },
  { label: '指定产品', value: CHOOSE_TYPE.SPECIFIED_PRODUCT },
]

// 产品版本枚举
export const PRODUCT_VERSION = {
  ALL: 0,
  LATEST: 1,
  LAST: 2,
}

export const productVersionBaisicList = [
  {
    value: PRODUCT_VERSION.ALL,
    label: '全部',
  },
  {
    value: PRODUCT_VERSION.LATEST,
    label: '最新版本',
  },
]
export const productVersionCompareBasicList = [
  ...productVersionBaisicList,
  {
    value: PRODUCT_VERSION.LAST,
    label: '上一版本',
  },
]

// 对比范围：
export const COMPARE_RANGE = {
  LAST_7_PERIODS: 0,
  LAST_4_WEEKS: 1,
  SAME_DAY_EACH_MONTH_7: 2,
}

export const COMPARE_RANGE_OPTIONS = [
  {
    label: '近7日同期数据(取近7天同一小时的数据)',
    value: COMPARE_RANGE.LAST_7_PERIODS,
  },
  {
    label: '近4周星期同期数据(取近4周同一星期同一小时的数据）',
    value: COMPARE_RANGE.LAST_4_WEEKS,
  },
  // {
  //   label: '连续时段：连续的7个小时或者7天等',
  //   value: COMPARE_RANGE.SAME_DAY_EACH_MONTH_7,
  // },
]

// 触发时机
export const TASK_TRIGGER_TYPE = {
  HOURLY: 0,
  DAILY: 1,
  CRON: 2,
}

export const TASK_TRIGGER_TYPE_OPTIONS = [
  { label: '每小时定时', value: TASK_TRIGGER_TYPE.HOURLY },
  // { label: '每天定时', value: TASK_TRIGGER_TYPE.DAILY },
  // { label: ' cron表达式', value: TASK_TRIGGER_TYPE.CRON },
]

export const DEFAUL_TRIGGER_TIME = '00:00:00'
